<template>
    <div>
        <rkm-row>
            <rkm-col cols="12">
                <div class="d-flex justify-content-center">
                    <Dente
                        v-for="dente in dentesSuperioresPermanentesData"
                        :key="dente.numero"
                        @click="abrirDente(dente)"
                        position="cima"
                        v-bind="handleDenteProps(dente)"
                    >
                        <template v-slot:popover>
                            <strong>Problemas/condições</strong>

                            <div
                                v-for="(problemaCondicao, index) in dente.problemasCondicoesNomes"
                                :key="index"
                            >
                                {{ problemaCondicao }}
                            </div>
                        </template>
                    </Dente>
                </div>
            </rkm-col>
        </rkm-row>

        <rkm-row
            v-if="!!data.model.odontograma.mostrarDentesDeciduos"
            class="mt-4"
        >
            <rkm-col cols="12">
                <div class="d-flex justify-content-center">
                    <Dente
                        v-for="dente in dentesSuperioresDeciduosData"
                        :key="dente.numero"
                        @click="abrirDente(dente)"
                        position="cima"
                        v-bind="handleDenteProps(dente)"
                    >
                        <template v-slot:popover>
                            <strong>Problemas/condições</strong>

                            <div
                                v-for="(problemaCondicao, index) in dente.problemasCondicoesNomes"
                                :key="index"
                            >
                                {{ problemaCondicao }}
                            </div>
                        </template>
                    </Dente>
                </div>
            </rkm-col>
        </rkm-row>

        <rkm-row
            v-if="!!data.model.odontograma.mostrarDentesDeciduos"
            class="mt-4"
        >
            <rkm-col cols="12">
                <div class="d-flex justify-content-center">
                    <Dente
                        v-for="dente in dentesInferioresDeciduosData"
                        :key="dente.numero"
                        @click="abrirDente(dente)"
                        position="baixo"
                        v-bind="handleDenteProps(dente)"
                    >
                        <template v-slot:popover>
                            <strong>Problemas/condições</strong>

                            <div
                                v-for="(problemaCondicao, index) in dente.problemasCondicoesNomes"
                                :key="index"
                            >
                                {{ problemaCondicao }}
                            </div>
                        </template>
                    </Dente>
                </div>
            </rkm-col>
        </rkm-row>

        <rkm-row class="mt-4">
            <rkm-col cols="12">
                <div class="d-flex justify-content-center">
                    <Dente
                        v-for="dente in dentesInferioresPermanentesData"
                        :key="dente.numero"
                        @click="abrirDente(dente)"
                        position="baixo"
                        v-bind="handleDenteProps(dente)"
                    >
                        <template v-slot:popover>
                            <strong>Problemas/condições</strong>

                            <div
                                v-for="(problemaCondicao, index) in dente.problemasCondicoesNomes"
                                :key="index"
                            >
                                {{ problemaCondicao }}
                            </div>
                        </template>
                    </Dente>
                </div>
            </rkm-col>
        </rkm-row>

        <rkm-row class="mt-3">
            <rkm-col cols="12">
                A parte marcada como <span class="text-danger"><strong>vermelho</strong></span> representa não tratado.
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="12">
                A parte marcada como <span class="text-primary"><strong>azul</strong></span> representa tratado.
            </rkm-col>
        </rkm-row>

        <ModalDente
            :data="data"
            ref="ModalDente"
        />
    </div>
</template>

<script>
// Components.
import Dente from '@/components/ambulatorio/atendimento/components/soap/components/plano/components/odontograma/components/dente/Dente'
import ModalDente from './Modal'

// Enums.
import saudeBucalDenteProblemaCondicao from '@/enums/ambulatorio/saudeBucalDenteProblemaCondicao'

export default {
    components: {
        Dente,
        ModalDente,
    },
    computed: {
        dentesSuperioresPermanentesData() {
            return this.getArcadas().superior.dentes.permanentes.map(this.comNomesCondicoes)
        },
        dentesSuperioresDeciduosData() {
            return this.getArcadas().superior.dentes.deciduos.map(this.comNomesCondicoes)
        },
        dentesInferioresDeciduosData() {
            return this.getArcadas().inferior.dentes.deciduos.map(this.comNomesCondicoes)
        },
        dentesInferioresPermanentesData() {
            return this.getArcadas().inferior.dentes.permanentes.map(this.comNomesCondicoes)
        },
    },
    data: () => ({
        enums: {saudeBucalDenteProblemaCondicao},
    }),
    methods: {
        comNomesCondicoes(dente) {
            dente.problemasCondicoesNomes = this.data.form.odontograma.problemasCondicoes
                .filter(problemaCondicao => dente.problemasCondicoes.includes(problemaCondicao.id))
                .map(problemaCondicao => problemaCondicao.nome)

            return dente
        },
        abrirDente(dente) {
            if (this.data.readonly || !!this.data.model.odontograma.id) {
                return
            }

            this.$refs.ModalDente.open(dente)
        },
        handleDenteProps(dente) {
            const props = {
                fragments: dente.fragmentos,
                iconColor: dente.problemasCondicoes.length > 0 || (dente.procedimentosClinicos && dente.procedimentosClinicos.length > 0) ? 'var(--success)' : null,
                showPopover: dente.problemasCondicoes.length > 0,
                title: dente.numero,
            }

            const problemasCondicoesToDisable = [
                this.enums.saudeBucalDenteProblemaCondicao.AUSENTE_A,
                this.enums.saudeBucalDenteProblemaCondicao.EXTRAIDO_E,
                this.enums.saudeBucalDenteProblemaCondicao.HIGIDO_H,
                this.enums.saudeBucalDenteProblemaCondicao.PROTESE_PARCIAL_REMOVIVEL,
                this.enums.saudeBucalDenteProblemaCondicao.PROTESE_TEMPORARIA,
                this.enums.saudeBucalDenteProblemaCondicao.INCLUSO_I,
            ]

            if (this.data.readonly || !!this.data.model.odontograma.id) {
                props.disabledButton = true
                props.disabledFragment = true
            }
            else if (this.data.model.odontograma.protesesTotais.includes('superior') && this.getDentesSuperiores().some(denteSuperior => denteSuperior.numero === dente.numero)) {
                props.disabledFragment = true
            }
            else if (this.data.model.odontograma.protesesTotais.includes('inferior') && this.getDentesInferiores().some(denteInferior => denteInferior.numero === dente.numero)) {
                props.disabledFragment = true
            }
            else if (dente.problemasCondicoes.some(problemaCondicao => problemasCondicoesToDisable.includes(problemaCondicao))) {
                props.disabledFragment = true
            }

            return props
        },
        getArcadas() {
            return this.data.model.odontograma.arcadas
        },
        getDentesSuperiores() {
            return this.getArcadas().superior.dentes.permanentes.concat(this.getArcadas().superior.dentes.deciduos)
        },
        getDentesInferiores() {
            return this.getArcadas().inferior.dentes.permanentes.concat(this.getArcadas().inferior.dentes.deciduos)
        },
    },
    props: {
        data: {type: Object, required: true},
    },
}
</script>
